import { formatImgSrc } from './formatImgSrc';

/**
 * 注意是占满屏幕
 * 如果要三倍图,请用formatBackgroundImageStyle
 */
export function formatFullWidthBgStyle(style = {}, { imgWidth, imgHeight, imgUrl } = {}) {
    return Object.assign(style, {
        backgroundImage: `url(${formatImgSrc({
            imgWidth,
            imgHeight,
            imgUrl,
        })})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        width: '100vw',
        height: `${(imgHeight * 100) / imgWidth}vw`,
    });
}
